const nepcon = {
  type: [
    {
      code: '301',
      label: '原始设备制造商/OEM',
    },
    {
      code: '302',
      label: '电子制造服务/EMS',
    },
    {
      code: '303',
      label: '原始设计制造商/ODM',
    },
    {
      code: '304',
      label: '原始品牌制造商/OBM',
    },
    {
      code: '305',
      label: '半导体封测厂',
    },
    {
      code: '306',
      label: '电子生产设备供应商',
    },
    {
      code: '307',
      label: '电子元件供应商',
    },
    {
      code: '308',
      label: '材料供应商',
    },
    {
      code: '309',
      label: '代理商/经销商/分销商',
    },
    {
      code: '310',
      label: '媒体',
    },
    {
      code: '311',
      label: '科研/协会/院校',
    },
    {
      code: '312',
      label: '行政机构/职能部门',
    },
    {
      code: '323',
      label: '半导体设计',
    },
    {
      code: '324',
      label: '半导体封测设备商',
    },
    {
      code: '313',
      label: '其他',
    },
  ],
  service: [
    {
      code: '1101',
      label: '汽车电子',
    },
    {
      code: '1102',
      label: '手机',
    },
    {
      code: '1103',
      label: '电脑及电脑周边产品',
    },
    {
      code: '1104',
      label: '家用电器',
    },
    {
      code: '1105',
      label: '无线、通信设备及系统',
    },
    {
      code: '1106',
      label: '航空航天及军用电子',
    },
    {
      code: '1107',
      label: '自动化及工控电子',
    },
    {
      code: '1108',
      label: '视听及数码电子产品',
    },
    {
      code: '1109',
      label: '智能家居及可穿戴产品',
    },
    {
      code: '1110',
      label: '安防电子',
    },
    {
      code: '1111',
      label: '医疗电子及设备',
    },
    {
      code: '1112',
      label: '轨道交通',
    },
    {
      code: '1113',
      label: 'LED照明',
    },
    {
      code: '1114',
      label: '服务型机器人及无人机',
    },
    {
      code: '1115',
      label: '仪器仪表',
    },
    {
      code: '1116',
      label: '新能源',
    },
    {
      code: '1117',
      label: '金融电子',
    },
    {
      code: '1118',
      label: '其他',
    },
  ],
  products: [
    {
      code: '202',
      label: '贴装技术和设备',
    },
    {
      code: '216',
      label: '焊接设备',
    },
    {
      code: '2281',
      label: '测试与测量设备',
    },
    {
      code: '2038',
      label: '点胶、喷涂设备',
    },
    {
      code: '203',
      label: '电子材料&防静电',
    },
    {
      code: '291',
      label: '其他表面贴装技术',
    },
    {
      code: '226',
      label: '工业机器人',
    },
    {
      code: '225',
      label: '系统集成',
    },
    {
      code: '292',
      label: '传动/气动设备&配件',
    },
    {
      code: '223',
      label: '运动控制设备',
    },
    {
      code: '213',
      label: '机器视觉及传感技术',
    },
    {
      code: '205',
      label: '工业自动化信息技术及控制软件',
    },
    {
      code: '2952',
      label: '电子制造服务',
    },
    {
      code: '230',
      label: '半导体封装及测试设备',
    },
    {
      code: '231',
      label: '半导体材料',
    },
    {
      code: '217',
      label: '电子元器件',
    },
    {
      code: '221',
      label: 'MINI LED生产设备及材料',
    },
    {
      code: '220',
      label: '其他',
    },
  ],
};

export default nepcon;
